import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { SitesViewComponent } from 'src/app/site-management/sites-view/site-view.component';
@Component({
  selector: 'app-mobile-drop-down',
  templateUrl: './mobile-drop-down.component.html',
  styleUrls: ['./mobile-drop-down.component.scss'],
})
export class MobileDropDownComponent implements OnInit, OnChanges, OnDestroy {
  subscription: Subscription | undefined;
  @Input() items: any | undefined;
  sharedData: any;
  constructor(
    private helperService: HelperService,
    public sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => (this.sharedData = sharedData)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.items?.currentValue?.length > 0 &&
      this.sharedData?.selectedSite?.siteName === ''
    ) {
      this.sharedDataService.setSelectedSite({
        siteName: this.items[0]?.siteName,
        siteId: this.items[0]?.siteId,
        siteTimeZone: this.items[0]?.siteTimeZone,
        commonAccessControl: this.items[0]?.commonAccessControl
      });
    }
  }

  openSiteModal(): void {
    this.helperService.openModalDialog(
      SitesViewComponent,
      this.items,
      'full-screen-modal'
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
